import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";
import {getDataLine} from "./utils_dataTables";

export const init = () => {
    $('#dataTable').on('draw.dt', (e) => {
        $('button.edit-siv-data').off('click');
        $('button.edit-siv-data').click((e) => {
            editSivData(e);
        })
    });
};

const editSivData = (e) => {
    let callFunction = new CallFunction('editSivData', 'fad fa-file-signature fa-3x'),
        obj = getDataLine(e).data;

    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';
    callFunction.showModal('Modification des données SIV.');
    callFunction.startLoading();
    $.ajax({
        url: urls.editSivData.replace('toRpDocEntryAdjudication', obj.DocEntryPV).replace('toRpDocEntryVehicle', obj.DocEntryVH),
        type: 'GET',
        success: function (html) {
            callFunction.modalBody.innerHTML = html;
            callFunction.addValidateBtn(() => {
                submitEditSivDataForm(obj);
            });
        },
        complete: function () {
            callFunction.stopLoading();
        },
        error: function () {
            callFunction.addUnknowError();
        }
    });
};

const submitEditSivDataForm = (obj) => {
    let formData = $('#pvEditSivForm').serialize();
    let callFunction = new CallFunction('editSivData', 'fad fa-address-card fa-3x');
    callFunction.startLoading();
    $.ajax({
        url: urls.editSivData.replace('toRpDocEntryAdjudication', obj.DocEntryPV).replace('toRpDocEntryVehicle', obj.DocEntryVH),
        data: formData,
        type: 'POST',
        success: function (html) {
            callFunction.modalBody.innerHTML = html;
        },
        error: function () {
            callFunction.addUnknowError();
        },
        complete: function () {
            callFunction.stopLoading();
            callFunction.addReloadButton();
        }
    })
};

export const getSIV = (rows) => {
    let callFunction = new CallFunction('getSIV', 'fad fa-layer-plus fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Demande SIV');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    callFunction.addValidateBtn(function () {
        let data = rows.toArray();
        callFunction.startLoading();
        $.ajax({
            data: {data},
            type: 'POST',
            url: urls.getSIV,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
            },
            error: function (rep) {
                callFunction.addUnknowError();
            },
            complete: function (rep) {
                callFunction.stopLoading();
                callFunction.addReloadButton();
            }
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/display_siv.js